import { render } from "./Alunos.vue?vue&type=template&id=2830187d"
import script from "./Alunos.vue?vue&type=script&lang=js"
export * from "./Alunos.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__